// @ core
const moment = require('moment');
// @ utilities
const { APIGet } = require('utilities/APIRequestHelper');
const get = require('lodash/object/get');
// @ constants
const actionTypes = require('constants/actionTypes');
const { DATE_FORMAT_API } = require('constants/index');

const clearFilter = () => {
    return {
        type: actionTypes.ACCOUNT_SETTLEMENTS_CLEAR_FILTERS
    };
};

const setFilter = newFilter => {
    return {
        type: actionTypes.SET_ACCOUNT_SETTLEMENTS_FILTER,
        payload: {
            filters: {
                date: {
                    from: newFilter.dateFrom,
                    isActive: true,
                    selected: newFilter.dateSelected,
                    to: newFilter.dateTo
                }
            }
        }
    };
};

const requestAccountSettlements = accountId => ({
    type: actionTypes.FETCH_ACCOUNT_SETTLEMENTS_REQUEST,
    payload: {
        accountId
    }
});

const requestAccountSettlementsSuccess = (accountId, data) => ({
    type: actionTypes.FETCH_ACCOUNT_SETTLEMENTS_SUCCESS,
    payload: {
        accountId,
        settlements: get(data, 'liquidaciones.datoLiquidacion', []),
        nextPage: get(data, '_links.nextPage.href', ''),
        contractsTable: get(data, 'repaginacion.tablaContratos')
    }
});

const requestAccountSettlementsFailure = (accountId, error) => ({
    type: actionTypes.FETCH_ACCOUNT_SETTLEMENTS_FAILURE,
    payload: {
        accountId,
        error
    }
});

const requestSettlements = accountId => (dispatch, getState) => {
    const immAccount = getState().accounts.getIn(['byId', accountId]);
    const immSettlementFilters = getState().accountsSettlements.get('filters');
    const defaultDate = moment().startOf('day');

    let toDate = immSettlementFilters.getIn(['date', 'to']) || defaultDate;
    let fromDate = immSettlementFilters.getIn(['date', 'from']) || moment(defaultDate).subtract(5, 'year');

    const params = {
        query: {
            producto: immAccount.get('product'),
            numeroContrato: immAccount.get('contractNumber'),
            fechaDesde: fromDate.format(DATE_FORMAT_API),
            fechaHasta: toDate.format(DATE_FORMAT_API)
        }
    };

    dispatch(requestAccountSettlements(accountId));
    return APIGet({dispatch, endpoint:'accountSettlements', params })
        .then(response => dispatch(requestAccountSettlementsSuccess(accountId, response)))
        .catch(response => {
            if (!!response.error) {
                dispatch(requestAccountSettlementsFailure(accountId, response.error));
            } else {
                 throw response;
            }
        });
};

const fetchSettlementsNextPage = accountId => {
    return {
        type: actionTypes.FETCH_ACCOUNT_SETTLEMENTS_NEXT_PAGE,
        payload: {
            accountId
        }
    };
};

const fetchSettlementsNextPageSuccess = (accountId, data) => {
    return {
        type: actionTypes.FETCH_ACCOUNT_SETTLEMENTS_NEXT_PAGE_SUCCESS,
        payload: {
            accountId,
            settlements: get(data, 'liquidaciones.datoLiquidacion', []),
            nextPage: get(data, '_links.nextPage.href', ''),
            contractsTable: get(data, 'repaginacion.tablaContratos')
        }
    };
};

const fetchSettlementsNextPageFailure = (accountId, error) => {
    return {
        type: actionTypes.FETCH_ACCOUNT_SETTLEMENTS_NEXT_PAGE_FAILURE,
        payload: {
            error
        }
    };
};

const requestSettlementsNextPage = accountId => (dispatch, getState) => {
    const nextPageURL = getState().accountsSettlements.getIn([accountId, 'nextPage']);

    const config = {
        dispatch,
        endpoint: 'accountSettlements',
        url: nextPageURL
    };

    dispatch(fetchSettlementsNextPage(accountId));
    return APIGet(config)
        .then(response => dispatch(fetchSettlementsNextPageSuccess(accountId, response)))
        .catch(response => {
            if (!!response.error) {
                dispatch(fetchSettlementsNextPageFailure(accountId, response.error));
            } else {
                throw response;
            }
        });
};

module.exports = {
    clearFilter,
    requestSettlements,
    requestSettlementsNextPage,
    setFilter
};
